import React, { useEffect, useState } from "react";
import { Box, Button, Card } from "@mui/material";
import useEmpLandUse from "./useEmpLandUse";
import { genderData, landSubUseTypes, landUseList, landUsesSchemeTypeList, siteInspRecommendation } from "../../citizen/TCPForms/data";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabNewTheme,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabNewTheme,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";
import SubStep1 from "../../citizen/AVPForms/formComponents/land-Use/Step1/SubStep1";
import SubStep2 from "../../citizen/AVPForms/formComponents/land-Use/Step1/SubStep2";
import SubStep3 from "../../citizen/AVPForms/formComponents/land-Use/Step1/SubStep3";
import SubStep4 from "../../citizen/AVPForms/formComponents/land-Use/Step1/SubStep4";
import Step2 from "../../citizen/AVPForms/formComponents/map-submission/Step2";
import { landUseSubTabDDocSecLabels, landUseSubTabLabels, primaryTabLabels, SidebarLabelsLandUse } from "../../citizen/AVPForms/components/data";
import LandUseNOC from "../../../components/LandUseNOC/LandUseNOC";
import DocumentSection from "../PurchasableFAR/DocumentSection";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
// import SubStep1 from "./Steps/SubStep1";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import CollapsibleHistory from "../NotingRemarks";
import CheckBox from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/CheckBox";
import ActionButtons from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ActionButtons";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import ChatBoard from "../../../components/ChatBoard";
import Architect from "../../../../../templates/ApplicationDetails/RoleAccess/Architect";
import { SelectMandatoryConditions2 } from "../../../../../templates/Forms/SelectMandatoryConditions2";
import ChatboardCorrespondenceApplicant from "../../../components/ChatBoard/ChatBoardApplicant/ChatBoardCorrespondenceApplicant";
import { BackButton } from "@egovernments/digit-ui-react-components";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import RecommendationRemarksComponent from "../RecommendationComponent";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import KhasraDetails from "./KhasraDetails";
import DrawingsDetailsTable from "../AllViewRemarks/DrawingsTable";
import KhasraDetailsLog from "./KhasraDetailsLog";
import DscLetters from "../DigitalSignLetters";
import DocumentSectionLog from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocumentSectionLog";
import useLocalizedData from "../../../utils/hooks/useLocalizedData";
import CollapsibleAdditionalRemarks from "../AdditionalRemarks";

const EmpLandUsePortal = ({ formData, submitAction, workflowDetails, userRolesArray }) => {
  const specialCondition = formData?.descriptionOfLand?.selectLandUse == "Conditional Permissible";
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("LU_CURRENT_TAB") || 0);
  const [subActiveTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("LU_CURRENT_SUBTAB") || 0);
  const [subActiveDocTab, setSelectedDocSubTab] = useState(0);
  const isApproved = formData?.status === "APPROVED";
  const {
    LANDUSE,
    ST_LABELS: subTabLabels,
    PT_LABELS: primaryTab,
    GENDER: genderList,
    SUBTYPE: landSubUses,
    LULIST: landUseListActivities,
    LUSCHEMELIST: landUsesSchemeList,
  } = useLocalizedData({
    LANDUSE: SidebarLabelsLandUse,
    ST_LABELS: landUseSubTabLabels,
    PT_LABELS: primaryTabLabels,
    GENDER: genderData,
    SUBTYPE: landSubUseTypes,
    LULIST: landUseList,
    LUSCHEMELIST: landUsesSchemeTypeList,
  });
  const {
    handleChange,
    currentTab,
    tabList,
    currentAction,
    onRadioActionSelect,
    Modal,
    tenantId,
    handleSubmit,
    error,
    setError,
    updatedDocuments,
    setUpdatedDocuments,
    isCitizen,
    updateApiCall,
    t,
    isEE,
    isDa,
    remarks,
    setRemarks,
    getTabIndex,
    taxHead,
    setTaxHead,
    applicationDocs,
    declarationMessage,
    mandatoryCondition,
    setMandatoryCondition,
    declarationMessage2,
    actions,
    officerNocDetails,
    setOfficerNocDetails,
    isNoNoc,
    setIsNoNoc,
    handleChangeCheckBox,
    checked,
    setChecked,
    uploadedFile,
    setUploadedFile,
    isLowRiskCase,
    documentSection,
    initialUrl,
    department,
    setInitialUrl,
    iframeSrc,
    setIframeSrc,
    isPreviewLoading,
    setIsPreviewLoading,
    currentView,
    setCurrentView,
    handleDocView,
    userRoles,
    handleChangePayment,
    showToast,
    closeToast,
    handleChangeForward,
    handleNoWorkflow,
    setDataRecommendation,
    setDataRecommendationDocument,
    onSelect,
    params,
    setParams,
    clearParams,
    dataRecommendationDocument,
    developerRemarksDocument,
    setDeveloperRemarksDocument,
    callKhasraDetailsApi,
    khasraDetailsData,
    updateKhasraDetails,
    callNotingDetailsAPI,
    developerRemarks,
    setDeveloperRemarks,
    notingRemarksData,
    setNotingRemarksData,
    khasraRemarks,
    setKhasraRemarks,
    avpLogo,
    daLogo,
    documentRemarksData,
    setDocumentRemarksData,
    isFromDashboard,
    callDocumentDetailsAPI,
    avpData,
    avpUnits,
    additionalComment,
    setAdditionalComment,
    handleAdditionalComment,
  } = useEmpLandUse(formData, workflowDetails, userRolesArray);

  const handleTabChange = (nextTabNo, formData = null) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("LU_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("LU_CURRENT_SUBTAB", nextSubTab);
  };
  const handleSubDocTabChange = (nextSubTab, formData = null) => {
    setSelectedDocSubTab(nextSubTab);
  };

  console.log("ParamsGOT", params, updatedDocuments);

  const renderContent = () => {
    if (activeTab === 0) {
      switch (subActiveTab) {
        case 0:
          return (
            <SubStep1
              formData={formData}
              isEmployee={!isCitizen}
              handleSubTabChange={handleSubTabChange}
              applicationFlow={department}
              isApproved={true}
              avpData={avpData}
              avpUnits={avpUnits}
            />
          );
        // case 1:
        //   return (
        //     <SubStep2
        //       formData={formData}
        //       isEmployee={!isCitizen}
        //       genderData={genderData}
        //       t={t}
        //       handleSubTabChange={handleSubTabChange}
        //       isApproved={true}
        //     />
        //   );
        case 1:
          return <SubStep3 formData={formData} isEmployee={!isCitizen} t={t} handleSubTabChange={handleSubTabChange} isApproved={true} />;
        case 2:
          return <SubStep4 formData={formData} isEmployee={!isCitizen} t={t} handleSubTabChange={handleSubTabChange} isApproved={true} />;
        default:
          return null;
      }
    } else if (activeTab === 1 && !isCitizen) {
      switch (subActiveDocTab) {
        case 0:
          return (
            <React.Fragment>
              <div className="view-doc-container">
                <Button
                  variant="contained"
                  className="view-doc-btn"
                  onClick={handleDocView}
                  style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
                >
                  <span className="view-doc-icon">
                    <ViewSidebarIcon />
                  </span>
                  {currentView === "documents" ? "View all documents" : "View document section"}
                </Button>
              </div>
              {currentView === "documents" ? (
                <React.Fragment>
                  <DocumentSection
                    formData={params}
                    handleChange={handleTabChange}
                    setUpdatedDocuments={setUpdatedDocuments}
                    updatedDocuments={updatedDocuments}
                    setIsPreviewLoading={setIsPreviewLoading}
                    setDataRecommendation={setDataRecommendationDocument}
                    onSelect={onSelect}
                    handleNoWorkflow={handleNoWorkflow}
                    attachedDocs={params?.documents || formData?.documents}
                    docType="mandatory"
                    formType="LANDUSE"
                    developerRemarks={developerRemarksDocument}
                    setDeveloperRemarks={setDeveloperRemarksDocument}
                    setError={setError}
                    callDocumentDetailsAPI={callDocumentDetailsAPI}
                    isFromDashboard={isFromDashboard}
                    ComposableComponent={(props) => (
                      <RecommendationRemarksComponent
                        title="Recommendation Details"
                        label="Recommendation"
                        name="recommendation" // just a field name, not value!
                        options={siteInspRecommendation}
                        defaultValue={dataRecommendationDocument}
                        extraLabel="Remarks"
                        setDeveloperRemarks={setDeveloperRemarksDocument}
                        developerRemarks={developerRemarksDocument}
                        setDataRecommendation={setDataRecommendationDocument}
                        error={error}
                        setError={setError}
                        {...props} // this includes `control`, injected later
                      />
                    )}
                  />
                  {!isCitizen && <DocumentSectionLog logData={documentRemarksData?.DetailDataRemarks} />}
                </React.Fragment>
              ) : (
                <ViewDocuments
                  documentSection={documentSection}
                  setIsPreviewLoading={setIsPreviewLoading}
                  iframeSrc={iframeSrc}
                  setIframeSrc={setIframeSrc}
                />
              )}
            </React.Fragment>
          );
        case 1:
          return (
            <React.Fragment>
              <DocumentSection
                formData={params}
                handleChange={handleTabChange}
                setUpdatedDocuments={setUpdatedDocuments}
                updatedDocuments={updatedDocuments}
                setIsPreviewLoading={setIsPreviewLoading}
                setDataRecommendation={setDataRecommendationDocument}
                onSelect={onSelect}
                callDocumentDetailsAPI={callDocumentDetailsAPI}
                handleNoWorkflow={handleNoWorkflow}
                attachedDocs={params?.documents || formData?.documents}
                docType="conditional"
              />
            </React.Fragment>
          );
      }
    } else if (activeTab === 1 && isCitizen) {
      return (
        <React.Fragment>
          <div className="view-doc-container">
            <Button
              variant="contained"
              className="view-doc-btn"
              onClick={handleDocView}
              style={{ backgroundColor: "#157C4F", borderRadius: "15px", padding: "5px 10px" }}
            >
              <span className="view-doc-icon">
                <ViewSidebarIcon />
              </span>
              {currentView === "documents" ? "View all documents" : "View document section"}
            </Button>
          </div>
          <ViewDocuments
            documentSection={documentSection}
            setIsPreviewLoading={setIsPreviewLoading}
            iframeSrc={iframeSrc}
            setIframeSrc={setIframeSrc}
          />
        </React.Fragment>
      );
    } else if (activeTab === 2 && !isCitizen) {
      return (
        <React.Fragment>
          <KhasraDetails
            callKhasraDetailsApi={callKhasraDetailsApi}
            updateKhasraDetails={updateKhasraDetails}
            formData={params}
            khasraRemarks={khasraRemarks}
            setKhasraRemarks={setKhasraRemarks}
            role={userRolesArray?.[0]?.code}
          />
          {/* <DrawingsDetailsTable detailData={khasraDetailsData?.DetailDataRemarks} /> */}
          <KhasraDetailsLog logData={khasraDetailsData?.DetailDataRemarks} />
        </React.Fragment>
      );
    } else if (activeTab === 2 && isCitizen) {
      return (
        <React.Fragment>
          <Architect formData={formData} applicationDocs={applicationDocs} actions={actions} avpLogo={avpLogo} daLogo={daLogo} />

          <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />
          {actions?.[0]?.action === "MAKE_PAYMENT" && (
            <div style={{ marginTop: "15px" }}>
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                <Box gridColumn="span 2"></Box>
                <Box gridColumn="span 8"></Box>
                <Box gridColumn="span 2">
                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                    Payment
                  </Button>
                </Box>
              </Box>
            </div>
          )}

          {/* {actions?.[0]?.action === "MAKE_PAYMENT_APPLICATION_FEE" && (
                <div style={{ marginTop: "15px" }}>
                  <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                    <Box gridColumn="span 2"></Box>
                    <Box gridColumn="span 8"></Box>
                    <Box gridColumn="span 2">
                      <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangePayment}>
                        Payment
                      </Button>
                    </Box>
                  </Box>
                </div>
              )} */}

          {actions?.[0]?.action === "FORWARD_TO_DEPARTMENT" && (
            <div style={{ marginTop: "15px" }}>
              <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
                <Box gridColumn="span 2"></Box>
                <Box gridColumn="span 6"></Box>
                <Box gridColumn="span 4">
                  <Button variant="contained" color="success" style={{ marginLeft: "10px" }} onClick={handleChangeForward}>
                    Forward To Department
                  </Button>
                </Box>
              </Box>
            </div>
          )}
        </React.Fragment>
      );
    } else if (activeTab === 3 && !isCitizen) {
      return (
        <React.Fragment>
          <PrimaryContent formData={formData} handleChange={handleChange} serviceName={"Land Use Verification"} avpLogo={avpLogo} daLogo={daLogo} />
          {!isApproved && (
            <CollapsibleHistory
              formData={formData}
              callNotingDetailsAPI={callNotingDetailsAPI}
              developerRemarks={developerRemarks}
              setDeveloperRemarks={setDeveloperRemarks}
              notingRemarksData={notingRemarksData}
              logoData={isDa ? daLogo : avpLogo}
            />
          )}
          {formData?.status?.startsWith("APPLY_FOR_DSC") && (
            <DscLetters formData={formData} handleChange={handleTabChange} isEmployee={!isCitizen} viewDrawing={false} pdfType={"LA"} />
          )}
          {/* {formData?.status?.startsWith("APPLY_FOR_DSC") && (
            <CollapsibleAdditionalRemarks
              formData={params || formData}
              additionalComment={additionalComment}
              setAdditionalComment={setAdditionalComment}
              handleSubmit={() => {
                console.log("additionalComment12", additionalComment);
                if (additionalComment.trim()?.length === 0) {
                  return;
                }
                handleAdditionalComment();
              }}
            />
          )} */}

          {/* {!isApproved && (
            <Card style={{ color: "red" }}>
              <CheckBox handleChangeCheckBox={handleChangeCheckBox} declarationMessage={declarationMessage} checked={checked} />
              {checked === false && <p>Please review the NOC checklist and select the applicable items to complete the form verification.</p>}
            </Card>
          )} */}
          {!isApproved && <ActionButtons actions={actions} currentAction={currentAction} onSelect={onRadioActionSelect} />}
          {!isApproved && <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />}
          {!isApproved && <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />}
          {!isApproved && !isFromDashboard && <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />}
        </React.Fragment>
      );
    }

    // else if (activeTab === 3 && isCitizen) {
    //   return (
    //     <React.Fragment>
    //       {/* {user?.info?.type === "CITIZEN" && formData?.status === "APPROVED" && <ViewLandUseNoc itemData={formData} />} */}
    //       {isCitizen && formData?.status === "APPROVED" && <LandUseNOC formData={formData} role="APPROVED_CITIZEN" />}
    //       {isCitizen && formData?.status !== "APPROVED" && <LandUseNOC formData={formData} role="VIEW_CITIZEN" />}
    //     </React.Fragment>
    //   );
    // }

    // else if (activeTab === 3 && !isCitizen) {
    //   return (
    //     <React.Fragment>
    //       <LandUseNOC
    //         formData={formData}
    //         role={"EMPLOYEE"}
    //         setOfficerNocDetails={setOfficerNocDetails}
    //         setCurrentTab={handleChange}
    //         setIsNoNoc={setIsNoNoc}
    //       />
    //     </React.Fragment>
    //   );
    // }
    else if (activeTab === 3 && isCitizen) {
      return (
        <React.Fragment>
          <ChatboardCorrespondenceApplicant formData={formData} />
        </React.Fragment>
      );
    } else if (specialCondition && !isCitizen && activeTab === 4) {
      return (
        <React.Fragment>
          <SelectMandatoryConditions2 setMandatoryCondition={setMandatoryCondition} tenantId={tenantId} setCurrentTab={handleChange} />
        </React.Fragment>
      );
    } else if (!specialCondition && !isCitizen && activeTab === 3) {
      return (
        <React.Fragment>
          <ChatBoard formData={formData} />
        </React.Fragment>
      );
    } else if (activeTab === 4 && isCitizen) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} formData={formData} />
        </React.Fragment>
      );
    } else if (!specialCondition && !isCitizen && activeTab === 4) {
      return (
        <React.Fragment>
          <ChatBoard formData={formData} />
        </React.Fragment>
      );
    } else if (activeTab === 5 && !isCitizen) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} formData={formData} />
        </React.Fragment>
      );
    }
    // else if (!specialCondition && !isCitizen && activeTab === 5) {
    //   return (
    //     <React.Fragment>
    //       <AllRemarksList remarkDataResps={workflowDetails?.data} />
    //     </React.Fragment>
    //   );
    // } else if (specialCondition && !isCitizen && activeTab === 5) {
    //   return (
    //     <React.Fragment>
    //       <ChatBoard formData={formData} />
    //     </React.Fragment>
    //   );
    // } else if (specialCondition && !isCitizen && activeTab === 6) {
    //   return (
    //     <React.Fragment>
    //       <AllRemarksList remarkDataResps={workflowDetails?.data} formData={formData} />
    //     </React.Fragment>
    //   );
    // }
  };

  return (
    <React.Fragment>
      <BackButton />
      <MainWrapper className="main-panel-corner land-use-corner">
        {/* <HeaderContent applicationFlow={applicationFlow} /> */}

        {!isCitizen && <EmpTopBar formData={formData} />}
        <Box sx={{ overflowY: "auto" }}>
          <PrimaryTabsWrapper>
            {/* Tabs Header */}
            <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
              <PrimaryTabNewTheme label="Application Data" />
              <PrimaryTabNewTheme label="Document Section" />
              {!isCitizen && <PrimaryTabNewTheme label="Land Use Details" />}
              <PrimaryTabNewTheme label="Take Action" />
              {/* <PrimaryTab label="NOC Checklist" /> */}
              {specialCondition && !isCitizen ? <PrimaryTabNewTheme label="Conditions" /> : null}
              <PrimaryTabNewTheme label="Chat-Board" />
              <PrimaryTabNewTheme label="All Remarks" />
            </PrimaryTabs>
          </PrimaryTabsWrapper>
          {activeTab === 0 && (
            <SubTabsWrapper>
              <SubTabs
                value={subActiveTab}
                onChange={(e, i) => handleSubTabChange(i)}
                aria-label="Sub Tab Group"
                variant="scrollable"
                scrollButtons="auto"
              >
                {subTabLabels.map((tab, index) => (
                  <SubTabNewTheme key={`${tab.text}.${index}`} label={tab.text} />
                ))}
              </SubTabs>
            </SubTabsWrapper>
          )}
          {activeTab === 1 && !isCitizen && (
            <SubTabsWrapper>
              <SubTabs
                value={subActiveDocTab}
                onChange={(e, i) => handleSubDocTabChange(i)}
                aria-label="Sub Tab Group"
                variant="scrollable"
                scrollButtons="auto"
              >
                {landUseSubTabDDocSecLabels.map((tab, index) => (
                  <SubTabNewTheme key={`${tab.text}.${index}`} label={tab.text} />
                ))}
              </SubTabs>
            </SubTabsWrapper>
          )}
          {/* <StyledDivider /> */}

          {renderContent()}
        </Box>
      </MainWrapper>
    </React.Fragment>
  );
};

export default EmpLandUsePortal;
